import { c as _c } from "react/compiler-runtime";
import { MapItemWithCoodId } from "@/types/search";
import React from "react";
import { GenericProjectsList } from "./generic-projects-list";
interface NonMatchingProjectsListProps {
  projectData: MapItemWithCoodId[];
  columnsCount: number;
}
export const NonMatchingProjectsList = React.memo(function NonMatchingProjectsList(t0) {
  const $ = _c(3);
  const {
    projectData,
    columnsCount
  } = t0;
  const headerContent = _temp;
  let t1;
  if ($[0] !== columnsCount || $[1] !== projectData) {
    t1 = <GenericProjectsList projectData={projectData} columnsCount={columnsCount} headerContent={headerContent} />;
    $[0] = columnsCount;
    $[1] = projectData;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
});
function _temp(t0) {
  const {
    count
  } = t0;
  if (count > 0) {
    const propertyText = count === 1 ? "property" : "properties";
    return {
      text: `${count} ${propertyText} around this location`,
      icon: <svg className="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
    };
  }
  return null;
}